<template>
  <a-card :bordered="false">
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="采销全流程">
                <a-select
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="projectFetching ? undefined : null"
                  show-search
                  allow-clear
                  v-model="queryParam.project_id"
                  placeholder="请输入名称"
                  :default-active-first-option="false"
                  @search="this.projectSearch"
                >
                  <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in projectList" :key="d.id">
                    {{ d.name }}（{{ d.number }}）
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="仓库">
                <a-select
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  allow-clear
                  v-model="queryParam.warehouse_id"
                  placeholder="请输入仓库"
                  :default-active-first-option="false"
                  @search="this.warehouseSearch"
                  @change="handleWarehouseChange"
                >
                  <a-select-option v-for="d in warehouseList" :key="d.id" :tt="d.name">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              </span>
            </a-col>
            <a-col :md="2" :sm="24" v-if="false">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleArchived">批量存档</a-button>
              </span>
            </a-col>
            <a-col :md="2" :sm="24" v-if="true">
              <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd">新建平账</a-button>
              <span class="table-page-search-submitButtons" v-if="false">
                <a-dropdown>
                  <a-menu slot="overlay" @click="handleAdd">
                    <a-menu-item v-for="(item, key) in this.$Dictionaries.trade_inventory_type" :key="key">
                      <a-icon type="plus" />{{ item }}
                    </a-menu-item>
                  </a-menu>
                  <a-button style="width: 120px" type="primary" icon="plus">新建出入库</a-button>
                </a-dropdown>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        ref="table"
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1000 }"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 300px">
          {{ (text / 1).toFixed(2) | numberFormat }}
        </div>
        <div slot="weight" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 300px">
          {{ (text / 1).toFixed(4) | numberFormat }}
        </div>
        <span slot="approval_needed" slot-scope="text">
          <span>{{ text ? '是' : '否' }}</span>
        </span>
        <span slot="archived" slot-scope="text, item">
          <a-popconfirm
            title="确定存档吗?"
            :disabled="text"
            @confirm="() => archived(item)">
            <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
          </a-popconfirm>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a-popconfirm
              v-if="!record.is_archived && isEdited(record.create_by_id)"
              title="确定要删除么？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
      <a-drawer
        title="库存调整"
        placement="right"
        :closable="false"
        :visible="visibleDrawer"
        @close="onClose"
        width="800">
        <a-spin :spinning="drawerLoading">
          <div v-if="inventoryAdjustmentObj" :title="inventoryAdjustmentObj.name">
            <a-row>
              <a-col span="12">
                <span class="desc_item_drawer">仓库：{{ inventoryAdjustmentObj.warehouse }}</span><br>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">提货单毛量：{{ (inventoryAdjustmentObj.gross_weight / 1).toFixed(4) | numberFormat }} {{ $Dictionaries.unit[inventoryAdjustmentObj.unit] }}</span><br>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">提货单净量：{{ (inventoryAdjustmentObj.net_weight / 1).toFixed(4) | numberFormat }} {{ $Dictionaries.unit[inventoryAdjustmentObj.unit] }}</span><br>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">过磅量：{{ (inventoryAdjustmentObj.weighing_capacity / 1).toFixed(4) | numberFormat }} {{ $Dictionaries.unit[inventoryAdjustmentObj.unit] }}</span><br>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">预估人民币单价：{{ (inventoryAdjustmentObj.unit_price_cny / 1).toFixed(2) | numberFormat }} </span>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">已开启审批：{{ inventoryAdjustmentObj.is_approval_needed ? '是' : '否' }}</span>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">审批状态：<span :class="statusText[inventoryAdjustmentObj.status < 0 ? 0 : inventoryAdjustmentObj.status][0]">{{ inventoryAdjustmentObj.is_approval_needed ? ($Dictionaries.approval_result[inventoryAdjustmentObj.status] ? $Dictionaries.approval_result[inventoryAdjustmentObj.status] : '无') : '未开启审批' }}</span></span><br>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">已存档：{{ inventoryAdjustmentObj.is_archived ? '是' : '否' }}</span>
              </a-col>
              <a-col span="12">
                <span class="desc_item_drawer">创建时间：{{ inventoryAdjustmentObj.create_time | dayjs }}</span>
              </a-col>
              <a-col span="24" v-if="inventoryAdjustmentObj.attachment">
                <div>
                  <a-collapse :bordered="false">
                    <template #expandIcon="props">
                      <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
                    </template>
                    <a-collapse-panel key="1" header="附件" v-if="inventoryAdjustmentObj.attachment.length > 0">
                      <a v-for="(attachment) in inventoryAdjustmentObj.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc_item_drawer"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
                    </a-collapse-panel>
                  </a-collapse>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-spin>
      </a-drawer>
      <create-form
        ref="createModal"
        v-if="visible"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        @cancel="handleAddCancel"
        @ok="handleOk"
      />
      <archived-form
        ref="archivedModal"
        :visible="archived_visible"
        @cancel="handleArchivedCancel"
        @ok="handleArchivedOK"
      />
    </div>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm2'
import ArchivedForm from '../modules/ArchivedForm'
import {
  inventory_list,
  inventory_create,
  inventory_delete,
  inventory_archived
} from '@/api/trade_inventory'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import { warehouse_list } from '@/api/trade_warehouse'
import { inventory_adjustment_list } from '@/api/trade_inventory_adjustment'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      drawerLoading: false,
      projectFetching: false,
      warehouseFetching: false,
      // 创建窗口控制
      visibleDrawer: false,
      inventoryAdjustmentObj: undefined,
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      },
      visible: false,
      archived_visible: false,
      mdl: {},
      projectList: [],
      warehouseList: [],
      // 查询参数
      queryParam: {
        type: 3
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采购合同编号',
          dataIndex: 'sell_contract',
          width: 150,
          ellipsis: true
        },
        {
          title: '仓库',
          dataIndex: 'warehouse',
          width: 150,
          ellipsis: true
        },
        {
          title: '耗损类型',
          dataIndex: 'loss_type',
          ellipsis: true,
          align: 'center',
          width: 100,
          customRender: (text) => this.$Dictionaries.trade_inventory_loss_type[text] || '无'
        },
        {
          title: '提货单毛量',
          dataIndex: 'gross_weight',
          scopedSlots: { customRender: 'weight' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '提货单净量',
          dataIndex: 'net_weight',
          scopedSlots: { customRender: 'weight' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '过磅量',
          dataIndex: 'weighing_capacity',
          scopedSlots: { customRender: 'weight' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '入库时间',
          dataIndex: 'in_out_date',
          width: 180,
          align: 'center',
          ellipsis: true,
          customRender: (text) => text === '1970-01-01' ? '' : text
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          width: 180,
          dataIndex: 'create_time',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '240px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return inventory_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl['number'] = year + '' + month + '' + day + '' + hours + minutes
      this.mdl['type'] = 3
      // this.mdl['project_id'] = this.$route.params.project_id
      // this.mdl = null
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/inventory/' + record.id + '/attachment', query: { project: record.project, warehouse: record.warehouse } })
    },
    handleAdjustment (record) {
      this.$router.push({ path: '/trade/inventory/' + record.id + '/adjustment', query: { project: record.project, warehouse: record.warehouse } })
    },
    archived (record) {
      inventory_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleAdjustmentDetail (record) {
      this.inventoryAdjustmentObj = undefined
      this.visibleDrawer = true
      this.drawerLoading = true
      inventory_adjustment_list({ inventory_id: record.id }).then(res => {
        if (res.code === 1000) {
          if (res.data.entries && res.data.entries.length > 0) {
            this.inventoryAdjustmentObj = res.data.entries[0]
          }
        }
      }).finally(() => {
        this.drawerLoading = false
      })
    },
    onClose () {
      this.visibleDrawer = false
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
      // this.$router.push({ path: '/trade/bank/' + record.id })
    },
    handleDelete (record) {
      inventory_delete(record.id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          console.log('删除成功------')
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values['type'] = 3
          values['attachment'] = data['attachment']
          inventory_create(values).then(res => {
            this.visible = false
            // 重置表单数据
            form.resetFields()
            if (res.code === 1000) {
              // 刷新表格
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    handleWarehouseSearch (value) {
      warehouse_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.warehouseList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleWarehouseChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleWarehouseSearch(value)
      }
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          inventory_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
<style scoped>
.desc_item_drawer {
  padding-left: 20px;
  height: 50px;
  line-height: 50px;
}
</style>
